/**
 * English and Spanish only, and only as whole words.
 *
 * Loqate fills `PostBox` from postal data for every language we ship to except Spanish,
 * where an apartado comes back as an ordinary address it could not place — so those two
 * languages are the ones a pattern has to know. Guessing at the rest would mean rejecting
 * the real streets that merely contain the letters: Pobřežní, Campobasso, Boxholmsvägen.
 *
 * Shared so the field the customer types into and the check on Loqate's answer cannot
 * disagree about what a PO box is.
 */
const PO_BOX_PATTERN =
    /\bP\.?\s*O\.?[\s-]*BOX\b|\bPOST\s*OFFICE\s*BOX\b|\bAPARTADO\b|\bAPDO\b/i

export const containsPoBox = (value: string): boolean => PO_BOX_PATTERN.test(value)
